import SimpleForm from '../UI/SimpleForm';
import * as formValidation from '../../util/formValidationMethods';

const DriverHelpdeskForm = ({onSubmit = () => {}, ...props}) => {
    const formElements = {
        subject: {
            type: 'text', 
            placeholder: 'Subject', 
            validate: [formValidation.required]
        }, 
        description: {
            type: 'text', 
            multiline: true, 
            minRows: 4, 
            placeholder: 'Description', 
            validate: [formValidation.required]
        }
    };

    return <SimpleForm 
        form='DriverHelpdesk' 
        formElements={formElements} 
        onSubmit={onSubmit} 
        {...props} 
    />
}

export default DriverHelpdeskForm;